/**
 * Per-chat recording sessions — Map<jid, session>.
 *
 * Session shape:
 *   recorder      – Mp3Recorder instance
 *   stream        – MediaStream (null when paused/tracks stopped)
 *   startedAt     – Date.now() of last resume
 *   accumulatedMs – total ms recorded before latest startedAt
 *   ampHistory    – waveform bar data for visual persistence
 *   status        – 'recording' | 'paused'
 */
const sessions = new Map();

export function getSession(jid) {
   return sessions.get(jid) || null;
}

export function setSession(jid, session) {
   sessions.set(jid, session);
}

export function updateSession(jid, patch) {
   const s = sessions.get(jid);
   if (s) Object.assign(s, patch);
}

export function deleteSession(jid) {
   sessions.delete(jid);
}

export function isActive(jid) {
   const s = sessions.get(jid);
   return !!s && (s.status === 'recording' || s.status === 'paused');
}

/** Compute elapsed milliseconds from timestamps — no interval needed */
export function getElapsedMs(session) {
   if (!session) return 0;
   const base = session.accumulatedMs || 0;
   if (session.status === 'recording') {
      return base + (Date.now() - session.startedAt);
   }
   return base;
}

/** Elapsed as whole seconds */
export function getElapsedSec(session) {
   return Math.floor(getElapsedMs(session) / 1000);
}

/** Stop ALL sessions — used when a VoIP call starts and needs the mic */
export function cancelAllSessions() {
   sessions.forEach(session => {
      session.recorder?.stop();
   });
   sessions.clear();
}
